// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remove-button.ui-button{color:var(--color-rosso)}.remove-button .ui-icon{fill:var(--color-rosso)}", ""]);
// Exports
module.exports = exports;
